// extracted by mini-css-extract-plugin
export default {"rowBorder":"ViewCheckInPage_rowBorder__ggLfP","title":"ViewCheckInPage_title__+UmRu","content":"ViewCheckInPage_content__4b1NG"};